import { Typography, keyframes } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import styled from "@emotion/styled";

const drawCircle = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)`
  margin-left: auto;
  margin-right: auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 2px solid ${(p) => p.theme.colors.success};
  animation: ${drawCircle} 1s ease-out forwards;
`;

export const SuccessAnimatedIcon = () => {
  return (
    <AnimatedTypography variant="h1" mb={3} mt={3} textAlign="center">
      <CheckIcon fontSize="large" color="success" />
    </AnimatedTypography>
  );
};
